module["exports"] = [
  "France"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/default_country.js
// module id = 1441
// module chunks = 0